import React, { ReactElement } from 'react';
import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core';

import { BarChart } from '@components';
import { NO_DATA } from '@constants';
import { StyledTableCell } from './table-report.styled';

import { formatNumber } from '@helpers';

interface TableReportProperties {
    header: string;
    data: Record<string, number>;
    colour: string;
}

export function TableReport({
    header,
    data,
    colour,
}: TableReportProperties): ReactElement {
    const getMaxValue = data => {
        // Filter out any values where the key is an empty string (and is not assigned a category)
        const filtered = Object.keys(data).reduce((object, key) => {
            object[key] = data[key];
            return object;
        }, {});

        const dataValues = Object.values(filtered) as number[];
        return Math.max(...dataValues);
    };

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <StyledTableCell colSpan={3} $paddingLeft={false}>
                            <strong>{header}</strong>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.keys(data).length === 0 && (
                        <TableRow>
                            <StyledTableCell $paddingLeft={false}>
                                {NO_DATA}
                            </StyledTableCell>
                        </TableRow>
                    )}
                    {Object.entries(data)
                        .sort(([, a], [, b]) => b - a)
                        .map(([key], index) => (
                            <TableRow key={index}>
                                <StyledTableCell
                                    component="th"
                                    scope="row"
                                    $paddingLeft={false}
                                >
                                    {key}
                                </StyledTableCell>
                                <StyledTableCell width="100" $paddingLeft>
                                    <BarChart
                                        value={data[key]}
                                        maxValue={getMaxValue(data)}
                                        colour={colour}
                                    ></BarChart>
                                </StyledTableCell>
                                <StyledTableCell align="right" $paddingLeft>
                                    {formatNumber(data[key])}
                                </StyledTableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
